export default __webpack_public_path__ + "static/media/P_Forms.3cea41c2.png";